export default '@@RESIFT/FETCH';
